import { useMemo } from "react";
import Pricing from "@/pages/Pricing";
import PricingIft from "@/pages/PricingIft";
import { resolveSiteSlug } from "@/config/siteConfig";

// -----------------------------------------------------------------------------
// PricingDispatcher — the SocialPulse "Support the mission" pricing page
// is the default at /pricing. On the IndianFamilyTree.com child site the
// same URL renders the IFT-only Free/Advance/Pro/Unlimited pricing table
// with Stripe INR checkout instead.
//
// Detection: reads ?site= override (dev), then falls back to the
// resolveSiteSlug() helper which inspects window.location.hostname.
// -----------------------------------------------------------------------------

export default function PricingDispatcher() {
  const isIft = useMemo(() => {
    try {
      const q = typeof window !== "undefined"
        ? new URLSearchParams(window.location.search).get("site")
        : null;
      const slug = resolveSiteSlug({ queryParam: q || "" });
      return (slug || "").toLowerCase().includes("indianfamilytree");
    } catch { return false; }
  }, []);

  return isIft ? <PricingIft /> : <Pricing />;
}
